import { useMutation, useQueryClient } from '@tanstack/react-query'
import { RankExperienceService } from '../services/RankExperienceService'
import { RankQueryKeys } from '@/modules/manage-rank/keys'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import type { components } from '@/schema'

type UpdateRankExperienceSettingDto =
	components['schemas']['UpdateRankExperienceSettingDto']

export default function useMutationUpdateRankExperienceSetting() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (body: UpdateRankExperienceSettingDto) =>
			RankExperienceService.updateRankExperienceSetting(body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: RankQueryKeys.RANK_EXPERIENCE_SETTING,
			})
			toast.success('อัพเดทการตั้งค่าคะแนนประสบการณ์สำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
			console.error('Update rank experience setting error:', error)
		},
	})
}
